module.exports = __webpack_public_path__ + "static/media/vibe-logo.d65d6b8d.svg";